import { Navigate } from 'react-router-dom'
import { useIsAdmin } from '@/hooks/useIsAdmin'
import { useAppStore } from '@/store/useAppStore'

export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { authLoading } = useAppStore()
  const isAdmin = useIsAdmin()

  if (authLoading) return null
  if (!isAdmin) return <Navigate to="/app" replace />
  return <>{children}</>
}
